import api from '../../services/api';
import { CommentItem } from '../../services/comments';

export type AdminCommentsList = {
  items: CommentItem[];
  total: number;
  page: number;
  page_size: number;
};

export async function adminListComments(params: { status?: 'visible'|'hidden'; target_type?: string; target_id?: string; user_id?: string; page?: number; page_size?: number; }): Promise<AdminCommentsList> {
  const res = await api.get('/admin/comments', { params });
  return res.data as AdminCommentsList;
}

export async function adminUpdateCommentStatus(id: number, status: 'visible'|'hidden'): Promise<{ ok: boolean }>{
  const res = await api.patch(`/admin/comments/${id}/status`, { status });
  return res.data as { ok: boolean };
}

export async function adminBanUser(user_id: number, reason: string, duration_hours?: number): Promise<{ ok: boolean }>{
  const res = await api.post('/admin/comments/ban', { user_id, reason, duration_hours: duration_hours || 0 });
  return res.data as { ok: boolean };
}

export type CommentBan = {
  id: number;
  user_id: number;
  reason?: string;
  until?: string | null;
  created_at: string;
  created_by_id?: number;
  user?: {
    id: number;
    first_name?: string;
    last_name?: string;
    email?: string;
    role?: string;
    username?: string;
  };
};

export async function adminListBans(): Promise<{ items: CommentBan[] }>{
  const res = await api.get('/admin/comments/bans');
  return res.data as { items: CommentBan[] };
}

export async function adminLiftBan(id: number): Promise<{ ok: boolean }>{
  const res = await api.post(`/admin/comments/bans/${id}/lift`);
  return res.data as { ok: boolean };
}

export type UnbanRequest = {
  id: number;
  user_id: number;
  message: string;
  status: 'pending'|'approved'|'rejected';
  created_at: string;
  resolved_by_id?: number | null;
  resolved_at?: string | null;
  user?: {
    id: number;
    first_name?: string;
    last_name?: string;
    email?: string;
    role?: string;
    username?: string;
  };
};

export async function adminListUnbanRequests(): Promise<{ items: UnbanRequest[] }>{
  const res = await api.get('/admin/comments/unban-requests');
  return res.data as { items: UnbanRequest[] };
}

export async function adminResolveUnban(id: number, action: 'approve'|'reject'): Promise<{ ok: boolean }>{
  const res = await api.post(`/admin/comments/unban-requests/${id}/resolve`, { action });
  return res.data as { ok: boolean };
}
